var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5723 30.8967C20.5723 33.0407 22.3103 34.7787 24.4543 34.7787H28.059C30.3562 34.7787 32.2184 32.9165 32.2184 30.6194C32.2184 28.3223 30.3562 26.4601 28.059 26.4601H24.7316C22.4345 26.4601 20.5723 24.5979 20.5723 22.3008C20.5723 20.0036 22.4345 18.1414 24.7316 18.1414H28.3363C30.4803 18.1414 32.2184 19.8795 32.2184 22.0235M26.3953 8.6582V18.1414M26.3953 34.7787V37.2743",
    stroke: "#0F0F0F",
    strokeWidth: 4.65844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2062 11.5698L45.0292 14.4813V22.0513L50.27 27.292L45.0292 32.5328V41.2674C41.7295 41.4615 34.8971 43.3637 33.9654 49.4196C31.0539 47.4786 23.9498 44.7612 18.8255 49.4196C18.2432 45.7317 15.0988 38.9381 7.17942 41.2674V33.6974C4.6561 30.7859 1.23992 24.3805 7.76173 22.0513V14.4813L13.003 11.5698",
    stroke: "#0F0F0F",
    strokeWidth: 4.65844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5723 9.82324L26.3953 4.0002L32.2184 9.82324",
    stroke: "#0F0F0F",
    strokeWidth: 4.65844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/Dollar.33911afba8aa973f11784cfb9e0ff4a8.svg";
export { ForwardRef as ReactComponent };